import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

type TFullScreenThemed = {
	size?: number;
};

const FullScreenThemed: React.FC<TFullScreenThemed> = ({ size }) => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg width={size ?? 16} height={size ?? 16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M4.88889 1H2.55556C2.143 1 1.74733 1.16389 1.45561 1.45561C1.16389 1.74733 1 2.143 1 2.55556V4.88889M15 4.88889V2.55556C15 2.143 14.8361 1.74733 14.5444 1.45561C14.2527 1.16389 13.857 1 13.4444 1H11.1111M1 11.1111V13.4444C1 13.857 1.16389 14.2527 1.45561 14.5444C1.74733 14.8361 2.143 15 2.55556 15H4.88889M11.1111 15H13.4444C13.857 15 14.2527 14.8361 14.5444 14.5444C14.8361 14.2527 15 13.857 15 13.4444V11.1111"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};

export default FullScreenThemed;
